var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#56436B",
    d: "M16.295 15.495c-6.07 0-11 4.92-11 11v3.5h21.99v-3.5c0-6.08-4.92-11-10.99-11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295id0)",
    d: "M16.295 15.495c-6.07 0-11 4.92-11 11v3.5h21.99v-3.5c0-6.08-4.92-11-10.99-11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295id1)",
    d: "M16.295 15.495c-6.07 0-11 4.92-11 11v3.5h21.99v-3.5c0-6.08-4.92-11-10.99-11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295id2)",
    d: "M23.311 18.094a.242.242 0 0 0-.059-.29c-1.856-1.602-4.346-2.486-6.954-2.486c-2.608 0-5.113.893-6.97 2.487a.242.242 0 0 0-.06.29c1.276 2.6 3.756 4.613 7.03 4.613c3.274 0 5.73-2.014 7.013-4.614"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295id3)",
    d: "M23.311 18.094a.242.242 0 0 0-.059-.29c-1.856-1.602-4.346-2.486-6.954-2.486c-2.608 0-5.113.893-6.97 2.487a.242.242 0 0 0-.06.29c1.276 2.6 3.756 4.613 7.03 4.613c3.274 0 5.73-2.014 7.013-4.614"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295id4)",
    d: "M23.311 18.094a.242.242 0 0 0-.059-.29c-1.856-1.602-4.346-2.486-6.954-2.486c-2.608 0-5.113.893-6.97 2.487a.242.242 0 0 0-.06.29c1.276 2.6 3.756 4.613 7.03 4.613c3.274 0 5.73-2.014 7.013-4.614"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295id5)",
    d: "M23.311 18.094a.242.242 0 0 0-.059-.29c-1.856-1.602-4.346-2.486-6.954-2.486c-2.608 0-5.113.893-6.97 2.487a.242.242 0 0 0-.06.29c1.276 2.6 3.756 4.613 7.03 4.613c3.274 0 5.73-2.014 7.013-4.614"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295id6)",
    d: "M23.311 18.094a.242.242 0 0 0-.059-.29c-1.856-1.602-4.346-2.486-6.954-2.486c-2.608 0-5.113.893-6.97 2.487a.242.242 0 0 0-.06.29c1.276 2.6 3.756 4.613 7.03 4.613c3.274 0 5.73-2.014 7.013-4.614"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295id7)",
    d: "M23.311 18.094a.242.242 0 0 0-.059-.29c-1.856-1.602-4.346-2.486-6.954-2.486c-2.608 0-5.113.893-6.97 2.487a.242.242 0 0 0-.06.29c1.276 2.6 3.756 4.613 7.03 4.613c3.274 0 5.73-2.014 7.013-4.614"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#f2295id1k)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#1F0F21",
    strokeWidth: 0.4,
    d: "M15.996 18.865c.063.043.17.08.28.084a.562.562 0 0 0 .28-.084c1.017-.696 1.78-1.389 1.78-2.586v-3.634c0-1.14-.92-2.06-2.06-2.06c-1.14 0-2.06.92-2.06 2.06v3.634c0 1.197.763 1.89 1.78 2.586Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295id8)",
    d: "M15.996 18.865c.063.043.17.08.28.084a.562.562 0 0 0 .28-.084c1.017-.696 1.78-1.389 1.78-2.586v-3.634c0-1.14-.92-2.06-2.06-2.06c-1.14 0-2.06.92-2.06 2.06v3.634c0 1.197.763 1.89 1.78 2.586"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295id9)",
    d: "M15.996 18.865c.063.043.17.08.28.084a.562.562 0 0 0 .28-.084c1.017-.696 1.78-1.389 1.78-2.586v-3.634c0-1.14-.92-2.06-2.06-2.06c-1.14 0-2.06.92-2.06 2.06v3.634c0 1.197.763 1.89 1.78 2.586"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295ida)",
    d: "M15.996 18.865c.063.043.17.08.28.084a.562.562 0 0 0 .28-.084c1.017-.696 1.78-1.389 1.78-2.586v-3.634c0-1.14-.92-2.06-2.06-2.06c-1.14 0-2.06.92-2.06 2.06v3.634c0 1.197.763 1.89 1.78 2.586"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295id28)",
    d: "M25.023 11.668V2.805h-.8v8.863z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295idb)",
    d: "M25.023 11.668V2.805h-.8v8.863z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295idc)",
    d: "M24.223 11.644a.837.837 0 1 0 .8 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295idd)",
    d: "M24.223 11.644a.837.837 0 1 0 .8 0z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#f2295id1l)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "url(#f2295id29)",
    strokeWidth: 0.15,
    d: "M24.726 3.709v7.767"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295id2a)",
    d: "m23.77 13.605l-.517 2.239a.45.45 0 0 0 .445.551h1.863a.45.45 0 0 0 .43-.557l-.542-2.24a.5.5 0 0 0-.485-.38h-.707a.5.5 0 0 0-.488.387"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295id2b)",
    d: "m23.77 13.605l-.517 2.239a.45.45 0 0 0 .445.551h1.863a.45.45 0 0 0 .43-.557l-.542-2.24a.5.5 0 0 0-.485-.38h-.707a.5.5 0 0 0-.488.387"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295ide)",
    d: "m23.77 13.605l-.517 2.239a.45.45 0 0 0 .445.551h1.863a.45.45 0 0 0 .43-.557l-.542-2.24a.5.5 0 0 0-.485-.38h-.707a.5.5 0 0 0-.488.387"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295idf)",
    d: "m23.77 13.605l-.517 2.239a.45.45 0 0 0 .445.551h1.863a.45.45 0 0 0 .43-.557l-.542-2.24a.5.5 0 0 0-.485-.38h-.707a.5.5 0 0 0-.488.387"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295idg)",
    d: "m23.77 13.605l-.517 2.239a.45.45 0 0 0 .445.551h1.863a.45.45 0 0 0 .43-.557l-.542-2.24a.5.5 0 0 0-.485-.38h-.707a.5.5 0 0 0-.488.387"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295idh)",
    d: "M9.06 29.995V18.21a10.972 10.972 0 0 0-3.765 8.286v3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295idi)",
    d: "M9.06 29.995V18.21a10.972 10.972 0 0 0-3.765 8.286v3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295id2c)",
    d: "M9.06 29.995V18.21a10.972 10.972 0 0 0-3.765 8.286v3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295idj)",
    d: "M23.52 29.995V18.21a10.972 10.972 0 0 1 3.765 8.286v3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295idk)",
    d: "M23.52 29.995V18.21a10.972 10.972 0 0 1 3.765 8.286v3.5z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#f2295id1m)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295id2d)",
    d: "M11.958 23.771c0-.188.155-.34.346-.34c.19 0 .345.152.345.34v6.093h-.691z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295id2e)",
    d: "M15.944 23.771c0-.188.155-.34.346-.34c.191 0 .346.152.346.34v6.093h-.692z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295id2f)",
    d: "M19.93 23.771c0-.188.155-.34.346-.34c.191 0 .346.152.346.34v6.093h-.691z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#f2295id1n)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#504A4C",
    d: "M20.568 5.12h-2.123a.492.492 0 1 1 .078-.98c.551.088 1.283.21 1.773.332c1.107.274 1.413.813 1.498 1.198a1.544 1.544 0 0 0-1.226-.55"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#f2295id1o)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#49373D",
    d: "M20.568 5.058h-2.123a.492.492 0 1 1 .078-.98c.551.087 1.283.21 1.773.33c1.107.275 1.413.814 1.498 1.199a1.544 1.544 0 0 0-1.226-.55"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#f2295id1p)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#725050",
    d: "M20.794 5.105h-2.188a.508.508 0 1 1 .081-1.01c.568.09 1.322.216 1.827.34c1.141.284 1.456.84 1.544 1.236a1.592 1.592 0 0 0-1.264-.566"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295idl)",
    d: "M21.226 12.078a1.67 1.67 0 0 0 .92-.314v.948c0 .91-.541 1.72-1.365 2.056c.174-.37.293-.772.352-1.202z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295idm)",
    d: "M11.325 12.078a1.67 1.67 0 0 1-.92-.314v.948c0 .91.541 1.72 1.365 2.056a4.162 4.162 0 0 1-.352-1.202z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#f2295id1q)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295idn)",
    d: "M11.363 13.62a3.987 3.987 0 0 0 3.956 3.469h1.921a3.987 3.987 0 0 0 3.957-3.468c.12-1.918.24-3.829.33-5.746a1.476 1.476 0 0 0-1.404-1.458h-1.426a2.466 2.466 0 0 1-2.252-1.47a.676.676 0 0 0-.627-.425h-1.296c-1.88 0-3.402 1.54-3.402 3.44c0 1.895.118 3.76.243 5.659"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295id2g)",
    d: "M11.363 13.62a3.987 3.987 0 0 0 3.956 3.469h1.921a3.987 3.987 0 0 0 3.957-3.468c.12-1.918.24-3.829.33-5.746a1.476 1.476 0 0 0-1.404-1.458h-1.426a2.466 2.466 0 0 1-2.252-1.47a.676.676 0 0 0-.627-.425h-1.296c-1.88 0-3.402 1.54-3.402 3.44c0 1.895.118 3.76.243 5.659"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295ido)",
    d: "M11.363 13.62a3.987 3.987 0 0 0 3.956 3.469h1.921a3.987 3.987 0 0 0 3.957-3.468c.12-1.918.24-3.829.33-5.746a1.476 1.476 0 0 0-1.404-1.458h-1.426a2.466 2.466 0 0 1-2.252-1.47a.676.676 0 0 0-.627-.425h-1.296c-1.88 0-3.402 1.54-3.402 3.44c0 1.895.118 3.76.243 5.659"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295idp)",
    d: "M11.363 13.62a3.987 3.987 0 0 0 3.956 3.469h1.921a3.987 3.987 0 0 0 3.957-3.468c.12-1.918.24-3.829.33-5.746a1.476 1.476 0 0 0-1.404-1.458h-1.426a2.466 2.466 0 0 1-2.252-1.47a.676.676 0 0 0-.627-.425h-1.296c-1.88 0-3.402 1.54-3.402 3.44c0 1.895.118 3.76.243 5.659"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295idq)",
    d: "M11.363 13.62a3.987 3.987 0 0 0 3.956 3.469h1.921a3.987 3.987 0 0 0 3.957-3.468c.12-1.918.24-3.829.33-5.746a1.476 1.476 0 0 0-1.404-1.458h-1.426a2.466 2.466 0 0 1-2.252-1.47a.676.676 0 0 0-.627-.425h-1.296c-1.88 0-3.402 1.54-3.402 3.44c0 1.895.118 3.76.243 5.659"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295idr)",
    d: "M11.363 13.62a3.987 3.987 0 0 0 3.956 3.469h1.921a3.987 3.987 0 0 0 3.957-3.468c.12-1.918.24-3.829.33-5.746a1.476 1.476 0 0 0-1.404-1.458h-1.426a2.466 2.466 0 0 1-2.252-1.47a.676.676 0 0 0-.627-.425h-1.296c-1.88 0-3.402 1.54-3.402 3.44c0 1.895.118 3.76.243 5.659"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295ids)",
    d: "M11.363 13.62a3.987 3.987 0 0 0 3.956 3.469h1.921a3.987 3.987 0 0 0 3.957-3.468c.12-1.918.24-3.829.33-5.746a1.476 1.476 0 0 0-1.404-1.458h-1.426a2.466 2.466 0 0 1-2.252-1.47a.676.676 0 0 0-.627-.425h-1.296c-1.88 0-3.402 1.54-3.402 3.44c0 1.895.118 3.76.243 5.659"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295idt)",
    d: "M11.363 13.62a3.987 3.987 0 0 0 3.956 3.469h1.921a3.987 3.987 0 0 0 3.957-3.468c.12-1.918.24-3.829.33-5.746a1.476 1.476 0 0 0-1.404-1.458h-1.426a2.466 2.466 0 0 1-2.252-1.47a.676.676 0 0 0-.627-.425h-1.296c-1.88 0-3.402 1.54-3.402 3.44c0 1.895.118 3.76.243 5.659"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295idu)",
    d: "M11.363 13.62a3.987 3.987 0 0 0 3.956 3.469h1.921a3.987 3.987 0 0 0 3.957-3.468c.12-1.918.24-3.829.33-5.746a1.476 1.476 0 0 0-1.404-1.458h-1.426a2.466 2.466 0 0 1-2.252-1.47a.676.676 0 0 0-.627-.425h-1.296c-1.88 0-3.402 1.54-3.402 3.44c0 1.895.118 3.76.243 5.659"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#f2295id1r)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D69790",
    d: "m15.867 10.272l-.602 1.872c-.103.385.144.77.493.77h.745c.35 0 .596-.391.494-.77l-.504-1.872c-.108-.415-.513-.415-.626 0"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#f2295id1s)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DEAB9D",
    d: "m15.886 10.078l-.541 1.872c-.11.385.155.77.53.77h.8c.376 0 .641-.391.531-.77l-.541-1.872c-.116-.415-.657-.415-.779 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295id2h)",
    d: "m15.886 10.078l-.541 1.872c-.11.385.155.77.53.77h.8c.376 0 .641-.391.531-.77l-.541-1.872c-.116-.415-.657-.415-.779 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295idv)",
    d: "m15.886 10.078l-.541 1.872c-.11.385.155.77.53.77h.8c.376 0 .641-.391.531-.77l-.541-1.872c-.116-.415-.657-.415-.779 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295id2i)",
    d: "m15.886 10.078l-.541 1.872c-.11.385.155.77.53.77h.8c.376 0 .641-.391.531-.77l-.541-1.872c-.116-.415-.657-.415-.779 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295idw)",
    d: "m15.886 10.078l-.541 1.872c-.11.385.155.77.53.77h.8c.376 0 .641-.391.531-.77l-.541-1.872c-.116-.415-.657-.415-.779 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295id2j)",
    d: "m15.886 10.078l-.541 1.872c-.11.385.155.77.53.77h.8c.376 0 .641-.391.531-.77l-.541-1.872c-.116-.415-.657-.415-.779 0"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#f2295id1t)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "url(#f2295id2k)",
    strokeWidth: 0.15,
    d: "M14.9 13.354h-.001a.23.23 0 0 0-.275.047a.214.214 0 0 0-.023.274c.355.537.972.894 1.674.894c.703 0 1.32-.357 1.675-.895a.217.217 0 0 0-.024-.275a.231.231 0 0 0-.274-.046a2.97 2.97 0 0 1-1.377.327a3 3 0 0 1-1.376-.326Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295idx)",
    d: "M16.275 13.755a3.06 3.06 0 0 1-1.41-.335c-.14-.07-.29.086-.202.213c.341.517.935.861 1.612.861s1.272-.344 1.613-.861c.087-.132-.062-.284-.202-.213a3.045 3.045 0 0 1-1.41.335"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#f2295id1u)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295id2l)",
    d: "M21.219 4.041c.524.18.994.546 1.29 1.07a2.414 2.414 0 0 1-.107 2.573a1.588 1.588 0 0 0-.276.89v1.21a1.776 1.776 0 0 0-.68-.273l.08-1.636a1.476 1.476 0 0 0-1.403-1.458h-1.426a2.467 2.467 0 0 1-2.252-1.47a.676.676 0 0 0-.627-.425h-1.296c-1.88 0-3.402 1.54-3.402 3.44l.03 1.566a1.741 1.741 0 0 0-.732.269V8.574a1.59 1.59 0 0 0-.276-.89a2.434 2.434 0 0 1-.146-2.49a2.387 2.387 0 0 1 1.324-1.147a2.73 2.73 0 0 0 1.41-1.13c.42-.673 1.154-.732 2.002-.732c.33 0 .643.07.934.19c.39.17.827.17 1.215 0c.287-.12.6-.19.93-.19c.858 0 1.615.076 2.03.764c.314.519.805.896 1.378 1.092"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295idy)",
    d: "M21.219 4.041c.524.18.994.546 1.29 1.07a2.414 2.414 0 0 1-.107 2.573a1.588 1.588 0 0 0-.276.89v1.21a1.776 1.776 0 0 0-.68-.273l.08-1.636a1.476 1.476 0 0 0-1.403-1.458h-1.426a2.467 2.467 0 0 1-2.252-1.47a.676.676 0 0 0-.627-.425h-1.296c-1.88 0-3.402 1.54-3.402 3.44l.03 1.566a1.741 1.741 0 0 0-.732.269V8.574a1.59 1.59 0 0 0-.276-.89a2.434 2.434 0 0 1-.146-2.49a2.387 2.387 0 0 1 1.324-1.147a2.73 2.73 0 0 0 1.41-1.13c.42-.673 1.154-.732 2.002-.732c.33 0 .643.07.934.19c.39.17.827.17 1.215 0c.287-.12.6-.19.93-.19c.858 0 1.615.076 2.03.764c.314.519.805.896 1.378 1.092"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295idz)",
    d: "M21.219 4.041c.524.18.994.546 1.29 1.07a2.414 2.414 0 0 1-.107 2.573a1.588 1.588 0 0 0-.276.89v1.21a1.776 1.776 0 0 0-.68-.273l.08-1.636a1.476 1.476 0 0 0-1.403-1.458h-1.426a2.467 2.467 0 0 1-2.252-1.47a.676.676 0 0 0-.627-.425h-1.296c-1.88 0-3.402 1.54-3.402 3.44l.03 1.566a1.741 1.741 0 0 0-.732.269V8.574a1.59 1.59 0 0 0-.276-.89a2.434 2.434 0 0 1-.146-2.49a2.387 2.387 0 0 1 1.324-1.147a2.73 2.73 0 0 0 1.41-1.13c.42-.673 1.154-.732 2.002-.732c.33 0 .643.07.934.19c.39.17.827.17 1.215 0c.287-.12.6-.19.93-.19c.858 0 1.615.076 2.03.764c.314.519.805.896 1.378 1.092"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295id10)",
    d: "M21.219 4.041c.524.18.994.546 1.29 1.07a2.414 2.414 0 0 1-.107 2.573a1.588 1.588 0 0 0-.276.89v1.21a1.776 1.776 0 0 0-.68-.273l.08-1.636a1.476 1.476 0 0 0-1.403-1.458h-1.426a2.467 2.467 0 0 1-2.252-1.47a.676.676 0 0 0-.627-.425h-1.296c-1.88 0-3.402 1.54-3.402 3.44l.03 1.566a1.741 1.741 0 0 0-.732.269V8.574a1.59 1.59 0 0 0-.276-.89a2.434 2.434 0 0 1-.146-2.49a2.387 2.387 0 0 1 1.324-1.147a2.73 2.73 0 0 0 1.41-1.13c.42-.673 1.154-.732 2.002-.732c.33 0 .643.07.934.19c.39.17.827.17 1.215 0c.287-.12.6-.19.93-.19c.858 0 1.615.076 2.03.764c.314.519.805.896 1.378 1.092"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295id11)",
    d: "M21.219 4.041c.524.18.994.546 1.29 1.07a2.414 2.414 0 0 1-.107 2.573a1.588 1.588 0 0 0-.276.89v1.21a1.776 1.776 0 0 0-.68-.273l.08-1.636a1.476 1.476 0 0 0-1.403-1.458h-1.426a2.467 2.467 0 0 1-2.252-1.47a.676.676 0 0 0-.627-.425h-1.296c-1.88 0-3.402 1.54-3.402 3.44l.03 1.566a1.741 1.741 0 0 0-.732.269V8.574a1.59 1.59 0 0 0-.276-.89a2.434 2.434 0 0 1-.146-2.49a2.387 2.387 0 0 1 1.324-1.147a2.73 2.73 0 0 0 1.41-1.13c.42-.673 1.154-.732 2.002-.732c.33 0 .643.07.934.19c.39.17.827.17 1.215 0c.287-.12.6-.19.93-.19c.858 0 1.615.076 2.03.764c.314.519.805.896 1.378 1.092"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#f2295id1v)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#202020",
    d: "M20.077 7.771a1.888 1.888 0 0 0-.7-.419c-.31-.097-.698-.123-1.235-.058a.282.282 0 0 0 .068.56c.49-.06.79-.028.997.037c.202.064.338.167.498.306a.283.283 0 0 0 .372-.426"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#f2295id1w)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#202020",
    d: "M12.802 7.66a2.824 2.824 0 0 1 1.77-.366a.282.282 0 1 1-.067.56a2.26 2.26 0 0 0-1.413.29a1.43 1.43 0 0 0-.093.062l-.003.002a.282.282 0 0 1-.346-.447z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#f2295id1x)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#23181C",
    d: "M16.512 5.087a2.544 2.544 0 0 1-.067-.139a.676.676 0 0 0-.627-.426h-1.296c-1.88 0-3.402 1.54-3.402 3.44v.28c-.346-.263-.782-.818-.782-1.718c0-1.091.796-1.643 1.304-1.995c.143-.099.264-.182.337-.258l.101-.106c.356-.378.99-1.05 2.098-1.344a5.575 5.575 0 0 1 1.55-.168c.472.013.806.42.806.894v1.527z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295id12)",
    d: "M16.512 5.087a2.544 2.544 0 0 1-.067-.139a.676.676 0 0 0-.627-.426h-1.296c-1.88 0-3.402 1.54-3.402 3.44v.28c-.346-.263-.782-.818-.782-1.718c0-1.091.796-1.643 1.304-1.995c.143-.099.264-.182.337-.258l.101-.106c.356-.378.99-1.05 2.098-1.344a5.575 5.575 0 0 1 1.55-.168c.472.013.806.42.806.894v1.527z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295id13)",
    d: "M16.512 5.087a2.544 2.544 0 0 1-.067-.139a.676.676 0 0 0-.627-.426h-1.296c-1.88 0-3.402 1.54-3.402 3.44v.28c-.346-.263-.782-.818-.782-1.718c0-1.091.796-1.643 1.304-1.995c.143-.099.264-.182.337-.258l.101-.106c.356-.378.99-1.05 2.098-1.344a5.575 5.575 0 0 1 1.55-.168c.472.013.806.42.806.894v1.527z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#f2295id1y)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1F151B",
    d: "m21.583 8.413l-.03-.642c-.01-.778-.653-1.42-1.43-1.452h-1.426c-.905 0-1.73-.495-2.163-1.283c0 0-.065-.15-.13-.405c-.249-.972.677-1.713 1.663-1.525c.998.192 2.142.527 2.986 1.077c1.776 1.159 1.465 3.247.53 4.23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295id14)",
    d: "m21.583 8.413l-.03-.642c-.01-.778-.653-1.42-1.43-1.452h-1.426c-.905 0-1.73-.495-2.163-1.283c0 0-.065-.15-.13-.405c-.249-.972.677-1.713 1.663-1.525c.998.192 2.142.527 2.986 1.077c1.776 1.159 1.465 3.247.53 4.23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295id15)",
    d: "m21.583 8.413l-.03-.642c-.01-.778-.653-1.42-1.43-1.452h-1.426c-.905 0-1.73-.495-2.163-1.283c0 0-.065-.15-.13-.405c-.249-.972.677-1.713 1.663-1.525c.998.192 2.142.527 2.986 1.077c1.776 1.159 1.465 3.247.53 4.23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295id16)",
    d: "m21.583 8.413l-.03-.642c-.01-.778-.653-1.42-1.43-1.452h-1.426c-.905 0-1.73-.495-2.163-1.283c0 0-.065-.15-.13-.405c-.249-.972.677-1.713 1.663-1.525c.998.192 2.142.527 2.986 1.077c1.776 1.159 1.465 3.247.53 4.23"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.71 9.11c.665 0 1.227.458 1.38 1.078a.28.28 0 0 1-.273.347h-2.272a.234.234 0 0 1-.231-.277A1.423 1.423 0 0 1 18.71 9.11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295id17)",
    d: "M18.499 9.386a.908.908 0 0 1 .875 1.148H17.62a.912.912 0 0 1 .88-1.148"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M17.979 10.295c0-.289.231-.52.52-.52a.518.518 0 0 1 .463.76h-.921a.47.47 0 0 1-.062-.24"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#f2295id1z)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C7A7A3",
    d: "M18.433 9.579c.064.086-.071.192-.225.307c-.154.115-.268.196-.333.11c-.064-.087.008-.25.162-.366c.154-.115.33-.138.396-.051"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295id18)",
    d: "M18.433 9.579c.064.086-.071.192-.225.307c-.154.115-.268.196-.333.11c-.064-.087.008-.25.162-.366c.154-.115.33-.138.396-.051"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#f2295id20)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295id2m)",
    d: "M19.308 10.175a.853.853 0 0 0-.235-.47l-.264.29l.119.231z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.84 9.11c-.664 0-1.226.458-1.379 1.078a.28.28 0 0 0 .273.347h2.272c.144 0 .26-.132.231-.277a1.427 1.427 0 0 0-1.396-1.148"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295id19)",
    d: "M14.051 9.386a.908.908 0 0 0-.875 1.148h1.755a.933.933 0 0 0 .033-.24a.915.915 0 0 0-.913-.908"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M14.571 10.295a.518.518 0 0 0-.52-.52a.518.518 0 0 0-.462.76h.92a.515.515 0 0 0 .062-.24"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#f2295id21)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295id2n)",
    d: "M14.882 10.189c0-.294-.239-.49-.303-.55l-.294.285l.18.368z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#f2295id22)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.777,
    cy: 9.775,
    fill: "#C7A7A3",
    fillOpacity: 0.9,
    rx: 0.397,
    ry: 0.201,
    transform: "rotate(-27.914 13.777 9.775)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.777,
    cy: 9.775,
    fill: "url(#f2295id1a)",
    rx: 0.397,
    ry: 0.201,
    transform: "rotate(-27.914 13.777 9.775)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295id2o)",
    d: "M21.288 12.17c.067-1.083.132-2.165.188-3.249a1.639 1.639 0 0 1-.188 3.25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295id1b)",
    d: "M21.288 12.17c.067-1.083.132-2.165.188-3.249a1.639 1.639 0 0 1-.188 3.25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295id1c)",
    d: "M21.288 12.17c.067-1.083.132-2.165.188-3.249a1.639 1.639 0 0 1-.188 3.25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295id1d)",
    d: "M21.288 12.17c.067-1.083.132-2.165.188-3.249a1.639 1.639 0 0 1-.188 3.25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295id2p)",
    d: "M11.139 8.912a1.648 1.648 0 0 0-1.417 1.623c0 .875.685 1.59 1.548 1.636a79.37 79.37 0 0 1-.131-3.259"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295id1e)",
    d: "M11.139 8.912a1.648 1.648 0 0 0-1.417 1.623c0 .875.685 1.59 1.548 1.636a79.37 79.37 0 0 1-.131-3.259"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#f2295id23)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295id1f)",
    d: "M11.097 9.585a.973.973 0 0 0 .085 1.913a79.905 79.905 0 0 1-.085-1.913"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#f2295id24)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295id2q)",
    d: "M21.373 11.515c.04-.646.078-1.292.113-1.938a.973.973 0 0 1-.113 1.938"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#f2295id25)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#353535",
    strokeLinecap: "round",
    strokeWidth: 0.15,
    d: "M12.84 7.945c.262-.188.914-.518 1.685-.388"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#f2295id26)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#353535",
    strokeLinecap: "round",
    strokeWidth: 0.15,
    d: "M19.902 7.898c-.262-.188-.914-.518-1.685-.388"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#f2295id27)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295id1g)",
    d: "m9.977 5.228l1.21-1.973l10.258-.109l1.117 2.02c-4.664 1.609-10.496.796-12.585.062"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295id1h)",
    d: "m9.977 5.228l1.21-1.973l10.258-.109l1.117 2.02c-4.664 1.609-10.496.796-12.585.062"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295id2r)",
    d: "M24.233 3.605H8.263c-.44 0-.8-.36-.8-.8c0-.44.36-.8.8-.8h15.96c.44 0 .8.36.8.8c.01.44-.35.8-.79.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295id1i)",
    d: "M24.233 3.605H8.263c-.44 0-.8-.36-.8-.8c0-.44.36-.8.8-.8h15.96c.44 0 .8.36.8.8c.01.44-.35.8-.79.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f2295id1j)",
    d: "M24.233 3.605H8.263c-.44 0-.8-.36-.8-.8c0-.44.36-.8.8-.8h15.96c.44 0 .8.36.8.8c.01.44-.35.8-.79.8"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295id0",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 10.875 -3.65625 0 23.592 23.114)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70647F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70647F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295id1",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1.3125 0 0 7.0625 8.998 21.458)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D516A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D516A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295id2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 -4.71875 15.8584 0 16.298 21.349)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.201,
    stopColor: "#46404E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A3142"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295id3",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 5.9375 -7.54205 0 16.29 16.896)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.932,
    stopColor: "#342542",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#342542"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295id4",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-5.88284 4.0234 -5.54695 -8.11053 15.873 15.552)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.928,
    stopColor: "#6A656F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A656F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295id5",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(6.76566 4.60934 -6.35476 9.32761 15.623 15.318)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.939,
    stopColor: "#655F6B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.971,
    stopColor: "#655F6B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295id6",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 -10.0625 10.6454 0 16.29 23.614)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#57525D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57525D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295id7",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 3.40625 -5.25876 0 16.29 16.063)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#170919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#361E27",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295id8",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-2.96875 -1.42188 1.19716 -2.49957 17.594 18.22)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD9E8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A56D67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B78273"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295id9",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 .9375 -2.06 0 16.276 16.985)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0797E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0797E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295ida",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 4.5407 -4.26182 0 16.276 14.544)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#B5836A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5836A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295idb",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 -2.33473 .18031 0 24.865 11.668)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70635D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70635D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295idc",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-.81259 1.10067 -.98646 -.72826 25.123 12.04)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#686071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661,
    stopColor: "#402A4C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295idd",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.79636 -.08984 .10538 .93405 23.785 12.431)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.087,
    stopColor: "#685352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#685352",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295ide",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(169.33 12.257 8.551)scale(1.11532 5.56401)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.286,
    stopColor: "#FFD93A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD93A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295idf",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 -1.3125 2.89043 0 24.623 16.896)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#9B6733"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB9820",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295idg",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 .39844 -1.38177 0 24.623 13.107)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#845D03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBA429",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295idh",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 -16.3734 4.36464 0 5.295 29.995)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#766C83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441,
    stopColor: "#58496A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4159"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295idi",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 -10.5202 .82413 0 9.06 29.995)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.286,
    stopColor: "#4F445B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F445B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295idj",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.88274 -10.19308 2.86286 -.5288 25.402 29.995)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#736782"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F5070"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295idk",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.5437 12.03342 -.70276 .03175 23.35 23.157)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.177,
    stopColor: "#3F2A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F2A51",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295idl",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.76245 2.0564 -2.44285 .90573 21.116 11.764)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.215,
    stopColor: "#313131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A161E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295idm",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(17.447 -34.905 39.07)scale(1.57592 4.86181)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746,
    stopColor: "#1E191C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295idn",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-5.32329 0 0 -9.41684 19.134 10.805)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDCC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6A195"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295ido",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "scale(10.7392 12.9682)rotate(90 .6 .971)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.764,
    stopColor: "#BE8689",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981,
    stopColor: "#A56F76"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295idp",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 -1.16931 1.44703 0 18.767 9.468)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.325,
    stopColor: "#F6B8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6B8A8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295idq",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.004 -1.11425 1.21257 .00436 13.933 9.516)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.378,
    stopColor: "#D39991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D39991",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295idr",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-8.65108 .5461 -1.39501 -22.09921 19.77 11.811)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.836,
    stopColor: "#E6AD97",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6AD97"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295ids",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.15498 -3.3376 1.2218 1.15494 10.708 6.401)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.428,
    stopColor: "#9F6D5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F6D5C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295idt",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(121.159 7.756 8.154)scale(3.43048 2.83214)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.078,
    stopColor: "#F6C3B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C3B0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295idu",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 2.35737 -6.02695 0 15.65 4.522)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#BF8679"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF8679",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295idv",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 .24856 -.78119 0 16.75 12.19)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDDC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDDC7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295idw",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(155.369 7.167 7.647)scale(1.70396 2.73839)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.714,
    stopColor: "#D3968C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3968C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295idx",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 -.7339 2.95264 0 16.275 14.41)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88014E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86004D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295idy",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 -3.56524 9.01608 0 10.95 7.86)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.536,
    stopColor: "#3E3433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E3433",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295idz",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.11612 -2.5584 4.533 .20575 21.225 9.194)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F4D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295id10",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-146.667 10.648 -1.66)scale(2.87483 2.11027)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5A5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E5A5B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295id11",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(58.465 6.62 14.309)scale(1.76215 4.08032)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.287,
    stopColor: "#484646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#484646",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295id12",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-2.24131 0 0 -.83184 16.534 3.483)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#423C3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423C3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295id13",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-57.724 12.174 -6)scale(6.13664 6.79876)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.093,
    stopColor: "#0B0306"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311,
    stopColor: "#1C0C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C0C20",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295id14",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.11422 0 0 1.21761 19.752 4.273)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E494B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E494B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295id15",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(2.72763 -2.59876 4.75766 4.99359 18.957 7.366)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.857,
    stopColor: "#545051",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#545051"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295id16",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.30751 .3866 -.16186 1.3848 18.055 5.863)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#200E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200E25",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295id17",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 .8257 -1.31337 0 18.497 9.872)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.802,
    stopColor: "#7D574A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#694B43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#804D49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#664842"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295id18",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-127.812 11.571 .506)scale(.38519 .53032)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.766,
    stopColor: "#FFE6E2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966,
    stopColor: "#FFE6E2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295id19",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 .82574 -1.31344 0 14.053 9.872)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.802,
    stopColor: "#7D574A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#694B43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#804D49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#664842"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295id1a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-.00788 -.5031 .60475 -.00947 13.762 10.096)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.766,
    stopColor: "#FFE6E2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966,
    stopColor: "#FFE6E2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295id1b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(74.347 3.97 18.776)scale(2.3722 2.26326)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopColor: "#CE978E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE978E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295id1c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.80216 -1.10084 .92272 .67237 21.345 10.441)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.664,
    stopColor: "#F7B99C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7B99C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295id1d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.59771 -1.57873 2.1094 .79863 21.461 10.617)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.803,
    stopColor: "#EBBB9D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBBB9D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295id1e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.64261 -.2007 .21544 -1.76327 11.27 10.542)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#E8AF99",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8AF99"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295id1f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-.93272 .1601 -.19646 -1.1445 11.27 10.541)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C18472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA8B7A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295id1g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-100.732 11.9 -4.871)scale(3.6749 8.45124)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#534D5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#372E41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295id1h",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 1.99817 -7.31619 0 16.238 2.866)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.263,
    stopColor: "#160C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#160C20",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295id1i",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 .9375 -12.6875 0 22.03 2.396)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#696070",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f2295id1j",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(7.75 0 0 .875 7.06 3.021)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75707B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#75707B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f2295id1k",
    width: 5.32,
    height: 9.564,
    x: 13.616,
    y: 9.985,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4002_1594",
    stdDeviation: 0.2
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f2295id1l",
    width: 0.65,
    height: 8.268,
    x: 24.401,
    y: 3.459,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4002_1594",
    stdDeviation: 0.125
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f2295id1m",
    width: 8.964,
    height: 6.734,
    x: 11.808,
    y: 23.281,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4002_1594",
    stdDeviation: 0.075
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f2295id1n",
    width: 5.842,
    height: 3.536,
    x: 16.952,
    y: 3.134,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4002_1594",
    stdDeviation: 0.5
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f2295id1o",
    width: 5.842,
    height: 3.536,
    x: 16.952,
    y: 3.071,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4002_1594",
    stdDeviation: 0.5
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f2295id1p",
    width: 5.96,
    height: 3.583,
    x: 17.098,
    y: 3.088,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4002_1594",
    stdDeviation: 0.5
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f2295id1q",
    width: 11.407,
    height: 12.767,
    x: 11.12,
    y: 4.522,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.913725 0 0 0 0 0.686275 0 0 0 0 0.592157 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4002_1594"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.780392 0 0 0 0 0.568627 0 0 0 0 0.486275 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_innerShadow_4002_1594",
    result: "effect2_innerShadow_4002_1594"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f2295id1r",
    width: 3.779,
    height: 4.953,
    x: 14.242,
    y: 8.961,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4002_1594",
    stdDeviation: 0.5
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f2295id1s",
    width: 2.312,
    height: 3.353,
    x: 15.12,
    y: 9.567,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4002_1594",
    stdDeviation: 0.1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f2295id1t",
    width: 3.777,
    height: 1.592,
    x: 14.387,
    y: 13.152,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4002_1594",
    stdDeviation: 0.05
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f2295id1u",
    width: 13.108,
    height: 8.112,
    x: 9.722,
    y: 1.685,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.625
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.137255 0 0 0 0 0.0901961 0 0 0 0 0.145098 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4002_1594"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0784314 0 0 0 0 0.0352941 0 0 0 0 0.0470588 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_innerShadow_4002_1594",
    result: "effect2_innerShadow_4002_1594"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f2295id1v",
    width: 2.38,
    height: 1.209,
    x: 17.894,
    y: 7.058,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.1,
    dy: -0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0588235 0 0 0 0 0.054902 0 0 0 0 0.0588235 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4002_1594"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f2295id1w",
    width: 2.38,
    height: 1.193,
    x: 12.541,
    y: 7.073,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.1,
    dy: -0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0588235 0 0 0 0 0.054902 0 0 0 0 0.0588235 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4002_1594"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f2295id1x",
    width: 7.195,
    height: 6.592,
    x: 9.838,
    y: 2.151,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.4,
    dy: 0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.286275 0 0 0 0 0.243137 0 0 0 0 0.227451 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4002_1594"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect2_foregroundBlur_4002_1594",
    stdDeviation: 0.25
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f2295id1y",
    width: 6.973,
    height: 6.337,
    x: 15.863,
    y: 2.577,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4002_1594",
    stdDeviation: 0.25
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f2295id1z",
    width: 0.798,
    height: 0.705,
    x: 17.752,
    y: 9.426,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4002_1594",
    stdDeviation: 0.05
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f2295id20",
    width: 0.899,
    height: 0.921,
    x: 18.609,
    y: 9.505,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4002_1594",
    stdDeviation: 0.1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f2295id21",
    width: 0.997,
    height: 1.052,
    x: 14.085,
    y: 9.44,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4002_1594",
    stdDeviation: 0.1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f2295id22",
    width: 0.926,
    height: 0.714,
    x: 13.314,
    y: 9.418,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4002_1594",
    stdDeviation: 0.05
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f2295id23",
    width: 1.344,
    height: 2.413,
    x: 10.088,
    y: 9.335,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4002_1594",
    stdDeviation: 0.125
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f2295id24",
    width: 1.964,
    height: 2.938,
    x: 20.873,
    y: 9.077,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4002_1594",
    stdDeviation: 0.25
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f2295id25",
    width: 2.335,
    height: 1.067,
    x: 12.516,
    y: 7.202,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4002_1594",
    stdDeviation: 0.125
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f2295id26",
    width: 2.335,
    height: 1.067,
    x: 17.892,
    y: 7.155,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4002_1594",
    stdDeviation: 0.125
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f2295id27",
    width: 12.586,
    height: 3.001,
    x: 9.977,
    y: 3.096,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.05
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.025
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.360784 0 0 0 0 0.337255 0 0 0 0 0.372549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4002_1594"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f2295id28",
    x1: 23.98,
    x2: 25.166,
    y1: 8.942,
    y2: 8.942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33203C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61546D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f2295id29",
    x1: 25.226,
    x2: 25.226,
    y1: 3.709,
    y2: 11.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60546C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#504B55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f2295id2a",
    x1: 25.774,
    x2: 23.455,
    y1: 14.806,
    y2: 14.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B72A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.897,
    stopColor: "#FAAC28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f2295id2b",
    x1: 23.406,
    x2: 24.469,
    y1: 14.603,
    y2: 14.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD9130"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB229",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f2295id2c",
    x1: 9.205,
    x2: 8.779,
    y1: 28.064,
    y2: 28.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.444,
    stopColor: "#433850"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#433850",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f2295id2d",
    x1: 16.29,
    x2: 16.29,
    y1: 29.864,
    y2: 23.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3748"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3748",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f2295id2e",
    x1: 16.29,
    x2: 16.29,
    y1: 29.864,
    y2: 23.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3748"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3748",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f2295id2f",
    x1: 16.29,
    x2: 16.29,
    y1: 29.864,
    y2: 23.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3748"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3748",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f2295id2g",
    x1: 21.527,
    x2: 17.095,
    y1: 12.521,
    y2: 12.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD6BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD6BA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f2295id2h",
    x1: 17.129,
    x2: 16.276,
    y1: 11.492,
    y2: 11.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFDFC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDFC7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f2295id2i",
    x1: 16.276,
    x2: 16.276,
    y1: 12.652,
    y2: 12.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D89793"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D89793",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f2295id2j",
    x1: 16.276,
    x2: 16.276,
    y1: 9.767,
    y2: 10.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8BBA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8BBA8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f2295id2k",
    x1: 15.052,
    x2: 15.376,
    y1: 14.252,
    y2: 13.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1ACA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1ACA6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f2295id2l",
    x1: 23.253,
    x2: 11.428,
    y1: 5.039,
    y2: 5.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#443D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272127"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f2295id2m",
    x1: 19.288,
    x2: 18.97,
    y1: 9.927,
    y2: 10.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4948D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4948D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f2295id2n",
    x1: 14.811,
    x2: 14.492,
    y1: 9.927,
    y2: 10.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4948D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4948D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f2295id2o",
    x1: 22.83,
    x2: 21.601,
    y1: 9.955,
    y2: 12.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD6BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0B8A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f2295id2p",
    x1: 10.319,
    x2: 11.804,
    y1: 10.671,
    y2: 10.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D19787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9887D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f2295id2q",
    x1: 21.855,
    x2: 21.855,
    y1: 9.577,
    y2: 11.515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9BB9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6BBA0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f2295id2r",
    x1: 18.06,
    x2: 16.779,
    y1: 3.958,
    y2: -0.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D294B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#433A4D"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.12f81c57a7f52ae129adc1bf0e717343.svg";
export { ForwardRef as ReactComponent };